'use strict';
module.exports = function removeExtraSpaces (string) {
	if (typeof string !== 'string') {
		return '';
	}
	return string.replace(/[ \t]+/g, ' ');
};
